// Master switch for customer-facing online payments (Settings → General → Payments). Default OFF.
import { useEffect, useState } from "react";
import { getSettings } from "@/lib/api";

let cached;
export async function onlinePaymentsEnabled() {
  if (cached === undefined) {
    try { cached = !!(await getSettings()).data?.online_payments_enabled; } catch { cached = false; }
  }
  return cached;
}
export const invalidateOnlinePayments = (value) => { cached = value === undefined ? undefined : !!value; };

export function useOnlinePayments() {
  const [on, setOn] = useState(cached === true);
  useEffect(() => { let live = true; onlinePaymentsEnabled().then(v => { if (live) setOn(v); }); return () => { live = false; }; }, []);
  return on;
}

// Shared customer-email copy — says "Pay Now" only while payments are switched on.
export const emailIntro = (noun, on) => on
  ? `Your ${noun} is available, click the link below to view.  A 'Pay Now' button is included on the ${noun} for a secure credit card or ACH payment.`
  : `Your ${noun} is available, click the link below to view.`;
export const viewLabel = (on) => (on ? "View & Pay" : "View");
